var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIosInstall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.91,401.67,210.35,281.2s-22-16-28.33-16.34a78.63,78.63,0,0,0-12.67,0s-41.67,15-41.67,18c0,2.85-1.8,108.25-2,118.81Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "rgba(0,109,195,1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.35,232.78S167.6,254,166.85,263s1,21,6.5,28.25,12.5,8.5,15-1.75,3-30.75,3-30.75-9.75-4-17-17.5S165.35,232.78,165.35,232.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.9,226.63s-4.75-1.5-5.5,3.25,3,12.5,5.25,14.75,5-.25,5-.25,2.25,10.25,6.5,15.75,12.75,11,19.75,8.75,15.5-15.75,18.75-23.25,1.75-14.25,3-18-4.5-18-9.25-21-32.5,7.75-37.75,11.75S159.9,226.63,159.9,226.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.15,179.13s-17.25,1.25-24.75,13.25,1.5,29.25,3.5,31.75a26.32,26.32,0,0,1,4.25,10.25c.5,3,3.25,8.5,4.25,8.5s-1-3.5.5-5.5a36.81,36.81,0,0,1,5.5-5s-2.75,5.5-.25,4.25,12.5-9,13.25-9-.5,4.75,4.5.25,15.5-12.25,15.5-12.25,4.5,10,6.25,12.25a14.15,14.15,0,0,1,2.25,5.75s3.25-3,4.5-9.75-1.75-18.5-1.75-18.5,2.25-4.5-1.25-12.5S196.9,175.63,177.15,179.13Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.05,
    y: 135.56,
    width: 160.62,
    height: 259.87,
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.67,
    y: 162.35,
    width: 57.39,
    height: 60.32,
    rx: 4.05,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background-simple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.71,289.85a145.65,145.65,0,0,0,.81-35.88c-10-103.84-108.89-208.71-220.3-176.76-38.49,11-67,36.83-84,72.51-12.46,26.18-21.3,56.48-41.57,78-33.25,35.35-73.39,90-22.93,132.83s112.37,9.64,165.12,4.28c44.34-4.5,89.14,7.54,133.34-.22C425.16,357.26,447,327,452.71,289.85Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.71,289.85a145.65,145.65,0,0,0,.81-35.88c-10-103.84-108.89-208.71-220.3-176.76-38.49,11-67,36.83-84,72.51-12.46,26.18-21.3,56.48-41.57,78-33.25,35.35-73.39,90-22.93,132.83s112.37,9.64,165.12,4.28c44.34-4.5,89.14,7.54,133.34-.22C425.16,357.26,447,327,452.71,289.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 128.59 144.18 128.59 145.03 117.34 229.68 117.34 228.83 128.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 144.34 144.18 144.34 145.03 133.09 229.68 133.09 228.83 144.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 160.09 144.18 160.09 145.03 148.84 229.68 148.84 228.83 160.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 175.84 144.18 175.84 145.03 164.59 229.68 164.59 228.83 175.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 191.59 144.18 191.59 145.03 180.34 229.68 180.34 228.83 191.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 207.35 144.18 207.35 145.03 196.09 229.68 196.09 228.83 207.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 223.1 144.18 223.1 145.03 211.85 229.68 211.85 228.83 223.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 238.85 144.18 238.85 145.03 227.6 229.68 227.6 228.83 238.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 254.6 144.18 254.6 145.03 243.35 229.68 243.35 228.83 254.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 270.35 144.18 270.35 145.03 259.1 229.68 259.1 228.83 270.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 286.1 144.18 286.1 145.03 274.85 229.68 274.85 228.83 286.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 128.59 233.68 128.59 234.54 117.34 319.19 117.34 318.33 128.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 144.34 233.68 144.34 234.54 133.09 319.19 133.09 318.33 144.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 160.09 233.68 160.09 234.54 148.84 319.19 148.84 318.33 160.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 175.84 233.68 175.84 234.54 164.59 319.19 164.59 318.33 175.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 191.59 233.68 191.59 234.54 180.34 319.19 180.34 318.33 191.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 207.35 233.68 207.35 234.54 196.09 319.19 196.09 318.33 207.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 223.1 233.68 223.1 234.54 211.85 319.19 211.85 318.33 223.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 238.85 233.68 238.85 234.54 227.6 319.19 227.6 318.33 238.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 254.6 233.68 254.6 234.54 243.35 319.19 243.35 318.33 254.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 270.35 233.68 270.35 234.54 259.1 319.19 259.1 318.33 270.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.33 286.1 233.68 286.1 234.54 274.85 319.19 274.85 318.33 286.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97,305c.06,0,.07-4.67,0-5-.34-3.38-2.77-9.45-6.1-9.77-2.4-.23-4.47,2.15-4.7,4.83s1.46,5.27,3.12,6.79C91.3,303.69,97,305,97,305Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,274.65c-3.36,1-6.1,7.59-6.61,11.05,0,.3-.27,5-.21,5l.07,0c-.43,1-.9,2.15-1.38,3.38-.88,2.28-1.85,4.85-2.75,7.72s-1.83,6-2.55,9.34a71,71,0,0,0-1.55,10.64s0,.09,0,.13c-.23-1.07-1-4-1-4.24-1.12-3.05-5-8-8.33-7.26-2.45.51-4,3.36-3.56,5.94s2.67,4.47,4.69,5.39c2.26,1,7.79.62,8.24.59A90.05,90.05,0,0,0,94,333c.13,2.07.33,4.15.54,6.22-.22-.91-.43-1.73-.47-1.83-1.12-3.05-5-8-8.34-7.27-2.44.52-3.94,3.36-3.55,5.94s2.67,4.47,4.68,5.39,6.76.69,8,.6l.27,2.39c.45,3.8.91,7.59,1.27,11.34.12,1.32.2,2.64.29,3.95-.21-.81-.38-1.49-.42-1.59-1.12-3.05-5-8-8.33-7.26-2.45.51-4,3.36-3.56,5.93s2.67,4.47,4.69,5.39,6.29.71,7.77.62c0,1.35.1,2.7.1,4,0,.91,0,1.77-.06,2.68s-.09,1.8-.14,2.68c-.15,1.71-.29,3.47-.47,5.13-.12,1.16-.25,2.26-.38,3.38-.11-1.32-.37-3.89-.42-4.1a15.74,15.74,0,0,0-3.9-7.25,5.46,5.46,0,0,0-.28-.92,3.51,3.51,0,0,0-5.6-1.62c-3,2.27-3.56,9.28-3,12.57,0,.2.63,2.23,1,3.5-.34-.69-.66-1.37-1-2.08-.7-1.41-1.43-2.78-2.21-4.27l-1.21-2.12c-.39-.72-.89-1.41-1.34-2.12-1.07-1.63-2.23-3.21-3.43-4.77,1.16-.85,5.23-3.91,6.64-6.13s2.68-5.4,2.07-7.95-2.93-3.89-5.22-2.61c-3.18,1.77-4.69,8.72-4.55,12.14,0,.21.36,2.62.57,3.94-.73-.93-1.45-1.86-2.22-2.77-2.21-2.63-4.54-5.2-6.84-7.77-.71-.79-1.4-1.58-2.1-2.38.41-.29,5.31-3.83,6.88-6.31,1.4-2.21,2.69-5.4,2.08-8s-2.93-3.89-5.22-2.61c-3.18,1.78-4.69,8.72-4.55,12.14,0,.26.52,3.73.68,4.6-1.54-1.75-3.05-3.51-4.48-5.33A67.35,67.35,0,0,1,53,340.8c.19-.14,5.32-3.81,6.93-6.35,1.4-2.21,2.69-5.4,2.08-7.95s-2.94-3.89-5.23-2.61c-3.18,1.77-4.69,8.72-4.54,12.14,0,.22.39,2.87.59,4.11l-.18.1a54.15,54.15,0,0,1-3.92-9c-.6-1.72-1.09-3.42-1.52-5.08,1-.58,5.57-3.28,7.23-5.41s3.15-5.1,2.8-7.75-2.5-4.28-4.87-3.29c-3.29,1.39-5.44,8.19-5.63,11.65,0,.19.06,2.09.14,3.48-.19-.76-.39-1.54-.56-2.27-.63-2.74-1.06-5.32-1.42-7.6-.19-1.31-.35-2.49-.48-3.61.79-1.12,3.9-5.69,4.58-8.3s.91-5.93-.5-7.95a3.63,3.63,0,0,0-5.92-.15c-2.54,2.9-1.8,9.71-.58,12.7.11.25,2.2,4,2.24,4l0-.07c.1,1.08.23,2.23.39,3.48.32,2.31.7,4.91,1.28,7.69a80.87,80.87,0,0,0,2.25,8.8,56.38,56.38,0,0,0,3.77,9.18l.06.1c-.72-.68-2.82-2.48-3-2.6-2.49-1.63-8.32-3-11-.29a5,5,0,0,0-.31,6.82c1.63,1.77,4.57,1.75,6.82,1.17,2.54-.64,7.32-4.47,7.69-4.78a70.7,70.7,0,0,0,5.34,8.21c1.13,1.51,2.31,3,3.52,4.44-.65-.56-1.23-1.06-1.32-1.11-2.49-1.64-8.32-3-11-.3a5.05,5.05,0,0,0-.31,6.83C50,361,53,361,55.23,360.39s6.4-3.76,7.48-4.61l1.4,1.66c2.25,2.64,4.51,5.26,6.65,7.92.75.94,1.46,1.9,2.17,2.86-.57-.5-1.06-.91-1.14-1-2.49-1.64-8.32-3-11-.3a5.05,5.05,0,0,0-.31,6.83c1.64,1.77,4.57,1.74,6.83,1.17s6-3.45,7.29-4.46c.7,1,1.4,2,2,3,.42.71.87,1.35,1.25,2.1L79,377.78c.7,1.41,1.42,2.85,2.07,4.25.46,1,.88,1.89,1.3,2.83-.74-.94-2.22-2.75-2.37-2.89-2.2-2.07-7.67-4.46-10.65-2.21a5.23,5.23,0,0,0-1.22,6.81c1.36,2.07,4.21,2.55,6.48,2.37,2.49-.2,7.44-3.08,8-3.44.7,1.55,1.37,3.07,2,4.52,2.11,5,3.69,9.31,4.76,12.34l.11.31,2.24-.95-.23-.6c-1.14-3-2.82-7.3-5-12.3-.71-1.59-1.48-3.26-2.3-5a57,57,0,0,0,4-4.24c2.15,1.3,7,1.82,7.64,1.88-.22,1.84-.45,3.63-.69,5.32-.81,5.85-1.68,10.71-2.33,14.11,0,.14,0,.26-.07.39l2.46-1c.57-3.38,1.28-7.95,1.93-13.38.23-1.87.44-3.87.64-5.92.66-.12,6-1.13,8.21-2.72,2-1.44,4.3-3.87,4.72-6.6s-1.09-5.14-3.53-5c-3.39.16-7.24,6.08-8.38,9.42-.07.2-.6,2.41-.91,3.8.08-.83.16-1.65.23-2.51.15-1.71.26-3.41.38-5.24l.09-2.67c0-.9,0-1.84,0-2.76,0-2.14-.16-4.3-.32-6.46,1.3,0,5.92-.2,8.08-1.3s4.69-3.15,5.46-5.83-.37-5.36-2.75-5.66c-3.31-.43-7.85,4.86-9.4,8-.1.2-1,2.58-1.48,3.9-.1-1.3-.21-2.59-.36-3.9-.43-3.76-1-7.54-1.49-11.32-.16-1.16-.31-2.32-.46-3.47.46,0,6-.07,8.37-1.31,2.15-1.09,4.69-3.14,5.46-5.82s-.37-5.36-2.75-5.67c-3.31-.42-7.85,4.86-9.4,8-.12.23-1.41,3.67-1.71,4.56-.33-2.55-.64-5.1-.86-7.63a90.61,90.61,0,0,1-.32-10.38c.21,0,5.93,0,8.41-1.3,2.15-1.1,4.69-3.15,5.46-5.83s-.36-5.36-2.75-5.66c-3.31-.43-7.84,4.85-9.39,8-.11.21-1.1,2.82-1.54,4.08l-.19,0A69.09,69.09,0,0,1,96,311.17c.37-1.93.82-3.76,1.3-5.54,1,.12,5.88.6,8.19-.27s4.9-2.58,5.92-5.18.16-5.44-2.15-6.05c-3.21-.84-8.17,3.9-10,6.89-.1.17-1,1.93-1.57,3.22.22-.8.44-1.63.67-2.39.84-2.87,1.77-5.46,2.6-7.74.48-1.3.94-2.46,1.38-3.54,1.15-.52,5.77-2.64,7.56-4.56s3.58-4.75,3.48-7.45S111.29,273.94,108.86,274.65Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.23,328.35c2.63.14,8.37-2.45,8.37-2.46s-2.2-3.63-2.37-3.84c-1.95-2.38-7.07-5.51-10.22-3.64a5.29,5.29,0,0,0-1.88,6.7C33.25,327.37,36,328.23,38.23,328.35Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 401.67,
    x2: 452.9,
    y2: 401.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,401.67,210.35,281.2s-22-16-28.33-16.34a78.63,78.63,0,0,0-12.67,0s-41.67,15-41.67,18c0,2.85-1.8,108.25-2,118.81Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.25 401.67 191.74 287.63 197.66 401.67 212.25 401.67",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,401.67,210.35,281.2s-22-16-28.33-16.34a78.63,78.63,0,0,0-12.67,0s-41.67,15-41.67,18c0,2.85-1.8,108.25-2,118.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.68,284.86c-1.33-2.66-23.33-11.66-23.33-11.66a19.67,19.67,0,0,0-5-5.67c-3.67-3-16.67-5.33-21.33-5.33s-8.34,2-12.67,2.66-7,5-7,5-36.33,12-39,12.67S111,289.2,112,300.86c1,11.15,7.69,93.47,8.29,100.81h46.05c.12-6.81,1.32-77.69,1.32-88.47,0-11.34-1.33-42.67-1.33-42.67,3.33-3,6.67-3.67,15.33-2s8,9.33,8,9.33l17.24,123.81h19.33l-3.9-28.14s4,7,7,8.67,18.5,4.55,22.5-2.12S225,287.53,223.68,284.86Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,271.82l-6.5,28.46s9.75,2,12.19,3.65,4.88,9.35,4.88,9.35",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,276.29l7.72,22.77s-5.69-.82-8.53,2-1.63,17.48-1.63,17.48",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,232.78S167.6,254,166.85,263s1,21,6.5,28.25,12.5,8.5,15-1.75,3-30.75,3-30.75-9.75-4-17-17.5S165.35,232.78,165.35,232.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.73,271.11c.48-6.77.62-12.33.62-12.33s-9.75-4-17-17.5-9-8.5-9-8.5S167.6,254,166.85,263A52.08,52.08,0,0,0,169,282.6l2.52-3.24s1.49-.22,8.32-1.71C184.33,276.67,188.43,273.32,190.73,271.11Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,271.11c.48-6.77.62-12.33.62-12.33s-9.75-4-17-17.5-9-8.5-9-8.5S167.6,254,166.85,263A52.08,52.08,0,0,0,169,282.6l2.52-3.24s1.49-.22,8.32-1.71C184.33,276.67,188.43,273.32,190.73,271.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,232.78S167.6,254,166.85,263s1,21,6.5,28.25,12.5,8.5,15-1.75,3-30.75,3-30.75-9.75-4-17-17.5S165.35,232.78,165.35,232.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,226.88s1,8.25-1.25,11.75-4.25,7-4.5,4.5,1.5-15.75,1.5-15.75S212.15,222.88,215.4,226.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,226.63s-4.75-1.5-5.5,3.25,3,12.5,5.25,14.75,5-.25,5-.25,2.25,10.25,6.5,15.75,12.75,11,19.75,8.75,15.5-15.75,18.75-23.25,1.75-14.25,3-18-4.5-18-9.25-21-32.5,7.75-37.75,11.75S159.9,226.63,159.9,226.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.07,265.58c-8.83,4.13-14.34,1.75-20-7.56s-7.26-25.61-7.26-25.61.19-8.72-2.94-14.15l-.17.12c-5.25,4-5.75,8.25-5.75,8.25s-4.75-1.5-5.5,3.25,3,12.5,5.25,14.75,5-.25,5-.25,2.25,10.25,6.5,15.75,12.75,11,19.75,8.75A15.11,15.11,0,0,0,196.07,265.58Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,265.58c-8.83,4.13-14.34,1.75-20-7.56s-7.26-25.61-7.26-25.61.19-8.72-2.94-14.15l-.17.12c-5.25,4-5.75,8.25-5.75,8.25s-4.75-1.5-5.5,3.25,3,12.5,5.25,14.75,5-.25,5-.25,2.25,10.25,6.5,15.75,12.75,11,19.75,8.75A15.11,15.11,0,0,0,196.07,265.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,226.63s-4.75-1.5-5.5,3.25,3,12.5,5.25,14.75,5-.25,5-.25,2.25,10.25,6.5,15.75,12.75,11,19.75,8.75,15.5-15.75,18.75-23.25,1.75-14.25,3-18-4.5-18-9.25-21-32.5,7.75-37.75,11.75S159.9,226.63,159.9,226.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,232.13s12,.75,13-.75-3.75-1.75-8.25-1.5S173.15,230.88,176.15,232.13Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,228.88s-9,.25-10.25,1.75,9,.75,10.75.25S210.65,228.38,208.65,228.88Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,236.88a9.55,9.55,0,0,0,6.5,2.25,8.15,8.15,0,0,0,6.25-2.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,237.38a7.9,7.9,0,0,0,5.25,2,5.71,5.71,0,0,0,4.75-2.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,232.13a5,5,0,0,0-2,5c.5,3.5,1,11-.25,11.75s-3,1.75-4.5-.25l-1.5-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,255.88s-.25,1-5.5.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.15,179.13s-17.25,1.25-24.75,13.25,1.5,29.25,3.5,31.75a26.32,26.32,0,0,1,4.25,10.25c.5,3,3.25,8.5,4.25,8.5s-1-3.5.5-5.5a36.81,36.81,0,0,1,5.5-5s-2.75,5.5-.25,4.25,12.5-9,13.25-9-.5,4.75,4.5.25,15.5-12.25,15.5-12.25,4.5,10,6.25,12.25a14.15,14.15,0,0,1,2.25,5.75s3.25-3,4.5-9.75-1.75-18.5-1.75-18.5,2.25-4.5-1.25-12.5S196.9,175.63,177.15,179.13Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.65,205.38s2.25-4.5-1.25-12.5c-2.87-6.57-12.15-14-26.3-14.48,3.66,1.1,9.58,3.39,8.51,5.53-1.48,2.95-18.86,12.08-14.73,11.79s18.26-10,19.15-3.83-25.34,20.33-20,21.21,29.76-20.62,25.34-13c-3.71,6.42-16.73,23.62-17.89,28.13.16-.13.3-.24.46-.39,5-4.5,15.5-12.25,15.5-12.25s.16.37.44,1c4.13-4,7.38-7.33,7.38-7.33a72.48,72.48,0,0,1,1.48,10c.25,2.83-.95,6.83-1.94,10.48a16.39,16.39,0,0,1,1.14,3.86s3.25-3,4.5-9.75S214.65,205.38,214.65,205.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.15,179.13s-17.25,1.25-24.75,13.25,1.5,29.25,3.5,31.75a26.32,26.32,0,0,1,4.25,10.25c.5,3,3.25,8.5,4.25,8.5s-1-3.5.5-5.5a36.81,36.81,0,0,1,5.5-5s-2.75,5.5-.25,4.25,12.5-9,13.25-9-.5,4.75,4.5.25,15.5-12.25,15.5-12.25,4.5,10,6.25,12.25a14.15,14.15,0,0,1,2.25,5.75s3.25-3,4.5-9.75-1.75-18.5-1.75-18.5,2.25-4.5-1.25-12.5S196.9,175.63,177.15,179.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.27,206.26c-1.21,1.65-2.66,3.51-4.3,5.41a132.62,132.62,0,0,1-9.75,10.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.51,199.88s-.7,1.22-2,3.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,209.23s-6.5,8.94-12.6,13.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.79,230.49c-.69.41-1.37.78-2,1.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,216.54a105.54,105.54,0,0,1-11.47,10.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.35,
    y1: 207.19,
    x2: 206.04,
    y2: 214.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,334l10.38-5.82s11.89-19,14.42-21.76,29.1-5.31,30.36-4.3-2.53,3-5.56,4.3-12.91,1.52-13.92,2.78-2.53,6.84-2.53,6.84,8.46-2.75,10.74-3,2.9.75,1.39,2.78-4,2.75-6.31,3.25-7.09,1.27-7.09,1.27-3.79,6.83-6.32,7.59a6.12,6.12,0,0,1-4,.07s-3.55,5.49-6.08,6.25A14.56,14.56,0,0,1,178,335l-9.86,11.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.17,313.09s.48-9.43,2.18-10.76,9.69-.4,11.2.19,6.36,7.55,7,8.68.76,2.41-.84,2.38-5.75-5.62-5.75-5.62l-7.82-1.25-2.39,4.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,316.82s3.29-8.85,5.32-9.61,9.36,2.53,10.62,3.54,3.8,9.11,4.05,10.38,0,2.53-1.52,2-3.79-7.08-3.79-7.08l-7.09-3.55-3.54,3.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,319.86s5.82-8.6,7.09-9.11,9.36,4.56,10.12,5.32-.76,8.35-1.77,9.1-1.52.76-1.52-1.51a39.42,39.42,0,0,0-.25-4.3l-7.34-1.52s.25,5.06-.76,7.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,282.05s-18.53,2.15-18.86,5.81,2.67,41.67,2.67,61,1.33,40.34,6,41.67,61.66-39.67,61.66-39.67L167.34,333,135,343.86l-.34-36.33",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,313.69,135,343.86s-17.67,7.67-21.67,12",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.02,
    y1: 343.86,
    x2: 166.07,
    y2: 334.03,
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.98,
    y: 290.47,
    width: 23.76,
    height: 48.65,
    rx: 2.74,
    transform: "translate(117.82 -57.27) rotate(19.47)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91,293.7a1.21,1.21,0,1,1-1.21-1.21A1.21,1.21,0,0,1,227.91,293.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.87 363.6 216.72 351.96 222.79 359.8 208.87 363.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,345s18.08-16,18.59-18.57-3.72-8.95-7.85-20.75c-1.31-3.74-3-.76-2.78,1.27s1.33,5.42,2,8.6c.38,1.75,2,7,2,7s-7-7.54-9.3-10.07-4.79-4.81-5.05-2.79,2,5.31,3.29,6.58,5.94,8.14,5.94,8.14l1.91,5.27s-5.15-4.85-7.18-7.13-6.23-6.53-7.5-6-1,2.53,0,3.8,4.17,4.44,5.18,5.95,6,6.95,6,6.95-3-1-6.33-2-9.11-3-9.87-3.8-2,0-1.26,1.77,2.27,1.52,4.8,2.79a46.25,46.25,0,0,1,5.06,3s-6,5-7.25,9.09,3.05,8.8,3.81,12.6,6.74,13.47,6.74,13.47l7-14.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.95,
    y1: 335.04,
    x2: 224.52,
    y2: 338.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,322.6s1.86,2.64,1.86,3.41a3.83,3.83,0,0,1-.62,1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.09,329.73a3.82,3.82,0,0,1-.05,3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.34,352.72,208.87,363.6s12.91,16.44,19.49,20.75,15.68,4.55,21-.76,4.28-20.41-3.54-23.53C240.76,358,227.34,352.72,227.34,352.72Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.34,
    y1: 352.72,
    x2: 245.82,
    y2: 360.06,
    className: "svg-bg",
    style: {
      fill: "#3F3D56",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.22,
    y: 99,
    width: 176.29,
    height: 333,
    rx: 7.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.05,
    y: 135.56,
    width: 160.62,
    height: 259.87,
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "427.68 308.12 277.94 395.44 427.68 395.44 427.68 308.12",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 267.05,
    y: 135.56,
    width: 160.62,
    height: 259.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,117.38H329.9a2.39,2.39,0,0,1-2.38-2.39h0a2.39,2.39,0,0,1,2.38-2.38h34.92a2.39,2.39,0,0,1,2.39,2.38h0A2.39,2.39,0,0,1,364.82,117.38Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,410.11a9.53,9.53,0,1,0-9.53,9.52A9.53,9.53,0,0,0,356.89,410.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.704333px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.54,
    y: 405.28,
    width: 9.65,
    height: 9.65,
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.67,
    y: 162.35,
    width: 57.39,
    height: 60.32,
    rx: 4.05,
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)"
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.67,211.17v7.44a4.05,4.05,0,0,0,4.05,4.06H372a4.06,4.06,0,0,0,4.05-4.06V169.73A153.28,153.28,0,0,0,318.67,211.17Z",
    style: {
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.74,188.71h-4.31a19.41,19.41,0,0,0-.79-3l3.73-2.15a.79.79,0,0,0,.29-1.09l-3-5.2a.81.81,0,0,0-1.1-.29l-3.73,2.15a21.82,21.82,0,0,0-2.15-2.15l2.15-3.73a.81.81,0,0,0-.29-1.1l-5.2-3a.79.79,0,0,0-1.09.29l-2.15,3.73a19.41,19.41,0,0,0-2.95-.79v-4.31a.8.8,0,0,0-.8-.8h-6a.8.8,0,0,0-.81.8v4.31a19.29,19.29,0,0,0-2.94.79l-2.15-3.73a.8.8,0,0,0-1.1-.29l-5.19,3a.81.81,0,0,0-.29,1.1L334,177a20.78,20.78,0,0,0-2.15,2.15L328.16,177a.81.81,0,0,0-1.1.29l-3,5.2a.79.79,0,0,0,.3,1.09l3.72,2.15a20.62,20.62,0,0,0-.78,3H323a.8.8,0,0,0-.8.8v6a.8.8,0,0,0,.8.81h4.31a20.49,20.49,0,0,0,.78,2.94l-3.72,2.15a.8.8,0,0,0-.3,1.1l3,5.19a.81.81,0,0,0,1.1.29l3.73-2.15A19.84,19.84,0,0,0,334,208l-2.15,3.73a.81.81,0,0,0,.29,1.1l5.19,3a.8.8,0,0,0,1.1-.3l2.15-3.72a20.49,20.49,0,0,0,2.94.78v4.31a.8.8,0,0,0,.81.8h6a.8.8,0,0,0,.8-.8v-4.31a20.62,20.62,0,0,0,2.95-.78l2.15,3.72a.79.79,0,0,0,1.09.3l5.2-3a.81.81,0,0,0,.29-1.1L360.69,208a20.78,20.78,0,0,0,2.15-2.15l3.73,2.15a.81.81,0,0,0,1.1-.29l3-5.19a.8.8,0,0,0-.29-1.1l-3.73-2.15a19.29,19.29,0,0,0,.79-2.94h4.31a.8.8,0,0,0,.8-.81v-6A.8.8,0,0,0,371.74,188.71Zm-24.38,20.44A16.65,16.65,0,1,1,364,192.51,16.64,16.64,0,0,1,347.36,209.15Z",
    className: "svg-bg",
    style: {
      fill: "#3F3D56"
    },
    fill: "#3F3D56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,280H284a5.14,5.14,0,0,1-5.14-5.14h0a5.14,5.14,0,0,1,5.14-5.14H410.74a5.14,5.14,0,0,1,5.14,5.14h0A5.14,5.14,0,0,1,410.74,280Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,269.68H284A5.14,5.14,0,0,0,284,280h91.35Z",
    className: "svg-accent",
    style: {
      fill: "rgb(0, 109, 195)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10
    },
    fill: "rgba(0,109,195,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,265.3a1.71,1.71,0,0,1-.74-.59,1.57,1.57,0,0,1-.28-.95,1.59,1.59,0,0,1,.33-1,1.48,1.48,0,0,1,.93-.55,1.39,1.39,0,0,1-.88-.52,1.61,1.61,0,0,1-.13-1.62,1.43,1.43,0,0,1,.43-.51,2,2,0,0,1,.62-.29,2.59,2.59,0,0,1,.74-.1,2.76,2.76,0,0,1,1,.17,1.63,1.63,0,0,1,.71.54,1.5,1.5,0,0,1,.27.9,1.37,1.37,0,0,1-1.16,1.43,1.5,1.5,0,0,1,1.25,1.56,1.57,1.57,0,0,1-.28.95,1.71,1.71,0,0,1-.74.59,2.82,2.82,0,0,1-1,.18A2.73,2.73,0,0,1,394,265.3Zm2-.65a1.06,1.06,0,0,0,.39-.88,1.14,1.14,0,0,0-.39-.92,1.59,1.59,0,0,0-1.94,0,1.17,1.17,0,0,0-.38.92,1.06,1.06,0,0,0,.39.88,1.7,1.7,0,0,0,1.93,0Zm0-3.07a1,1,0,0,0,.35-.81A.94.94,0,0,0,396,260a1.49,1.49,0,0,0-.93-.28,1.81,1.81,0,0,0-.63.11,1,1,0,0,0-.47.36,1,1,0,0,0-.19.63,1,1,0,0,0,.34.81,1.77,1.77,0,0,0,1.91,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,265.31a1.59,1.59,0,0,1-.61-.46,2.38,2.38,0,0,1-.38-.69,5.11,5.11,0,0,1-.2-.86,9.3,9.3,0,0,1-.05-1,7.73,7.73,0,0,1,.06-1,4.69,4.69,0,0,1,.2-.86,2.44,2.44,0,0,1,.38-.7,1.63,1.63,0,0,1,.61-.44,2.24,2.24,0,0,1,1.71,0,1.63,1.63,0,0,1,.61.44,2.44,2.44,0,0,1,.38.7,3.59,3.59,0,0,1,.2.86,7.73,7.73,0,0,1,.06,1,6.69,6.69,0,0,1,0,.8,6.37,6.37,0,0,1-.13.74,2.44,2.44,0,0,1-.25.64,2.12,2.12,0,0,1-.38.51,1.49,1.49,0,0,1-.56.33,2.19,2.19,0,0,1-.75.12A2.09,2.09,0,0,1,399.19,265.31Zm1.33-.48a1.09,1.09,0,0,0,.35-.24,2.07,2.07,0,0,0,.25-.36,3.89,3.89,0,0,0,.16-.44,3.07,3.07,0,0,0,.09-.49,4.79,4.79,0,0,0,.05-.49c0-.15,0-.3,0-.47s0-.41,0-.59,0-.38-.06-.59a2.67,2.67,0,0,0-.15-.56,3.21,3.21,0,0,0-.24-.45,1.07,1.07,0,0,0-.38-.32,1.25,1.25,0,0,0-.53-.11,1.06,1.06,0,0,0-.45.09,1,1,0,0,0-.35.23,1.35,1.35,0,0,0-.24.35,2.26,2.26,0,0,0-.17.43,5.07,5.07,0,0,0-.09.5,4.87,4.87,0,0,0-.05.51c0,.16,0,.33,0,.51s0,.33,0,.47a5,5,0,0,0,.05.5,3.3,3.3,0,0,0,.09.49,2.23,2.23,0,0,0,.16.43,1.27,1.27,0,0,0,.25.37,1.2,1.2,0,0,0,.34.23,1.14,1.14,0,0,0,.46.09A1.19,1.19,0,0,0,400.52,264.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,262.12a2,2,0,0,1,0-2.35,1.3,1.3,0,0,1,1-.47,1.35,1.35,0,0,1,.8.24,1.42,1.42,0,0,1,.49.6,2.13,2.13,0,0,1,.16.81,1.75,1.75,0,0,1-.4,1.17,1.41,1.41,0,0,1-2.1,0Zm1.47-.05a.78.78,0,0,0,.28-.29,2.74,2.74,0,0,0,.15-.4,2,2,0,0,0,0-.43,2.06,2.06,0,0,0,0-.44,2.26,2.26,0,0,0-.15-.39.78.78,0,0,0-.28-.29.93.93,0,0,0-.84,0,.78.78,0,0,0-.28.29,1.64,1.64,0,0,0-.14.39,1.56,1.56,0,0,0-.05.44,1.49,1.49,0,0,0,.05.43,1.32,1.32,0,0,0,.15.39.71.71,0,0,0,.28.29.7.7,0,0,0,.41.11A.82.82,0,0,0,405.44,262.07Zm-.45,3.56a.19.19,0,0,1-.07-.16.18.18,0,0,1,0-.09l3.46-6.07a.26.26,0,0,1,.24-.16.2.2,0,0,1,.16.07.21.21,0,0,1,.07.17.21.21,0,0,1,0,.12l-3.48,6.08a.19.19,0,0,1-.19.11A.27.27,0,0,1,405,265.63Zm3-.59a2,2,0,0,1,0-2.34,1.28,1.28,0,0,1,1.05-.48,1.35,1.35,0,0,1,.8.24,1.46,1.46,0,0,1,.49.61,2.07,2.07,0,0,1,.15.8,1.8,1.8,0,0,1-.39,1.17,1.39,1.39,0,0,1-2.1,0Zm1.47-.05a.81.81,0,0,0,.28-.3,1.64,1.64,0,0,0,.14-.39,1.49,1.49,0,0,0,.05-.43,1.56,1.56,0,0,0-.05-.44,1.64,1.64,0,0,0-.14-.39.86.86,0,0,0-.28-.29.93.93,0,0,0-.84,0,.86.86,0,0,0-.28.29,1.82,1.82,0,0,0-.14.39,2,2,0,0,0-.05.44,2,2,0,0,0,.05.43,1.32,1.32,0,0,0,.15.39.73.73,0,0,0,.28.3.76.76,0,0,0,.41.1A.82.82,0,0,0,409.5,265Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84,264.25a.82.82,0,0,1-.25-.63v-6.71a.82.82,0,0,1,.25-.63.81.81,0,0,1,.59-.24.84.84,0,0,1,.59.24.82.82,0,0,1,.25.63v6.71a.82.82,0,0,1-.25.63.85.85,0,0,1-.6.24A.8.8,0,0,1,285.84,264.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3,264.29a.83.83,0,0,1-.21-.6v-4.33a.7.7,0,0,1,.21-.54.78.78,0,0,1,.54-.2.77.77,0,0,1,.52.19.69.69,0,0,1,.2.54v.2a1.77,1.77,0,0,1,.76-.75,2.54,2.54,0,0,1,1.18-.26,2.3,2.3,0,0,1,.79.14,2.17,2.17,0,0,1,.67.4,1.9,1.9,0,0,1,.46.71,2.83,2.83,0,0,1,.17,1v2.9a.83.83,0,0,1-.21.6.73.73,0,0,1-.54.21.7.7,0,0,1-.52-.21.87.87,0,0,1-.2-.6v-2.9a1.32,1.32,0,0,0-.31-.93,1.09,1.09,0,0,0-.8-.32,1.36,1.36,0,0,0-1,.47,1.71,1.71,0,0,0-.43,1.2v2.48a.82.82,0,0,1-.2.6.72.72,0,0,1-.53.21A.71.71,0,0,1,289.3,264.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.89,263.52a.47.47,0,0,1,.13-.34.43.43,0,0,1,.34-.15.58.58,0,0,1,.3.09l.42.22a2.79,2.79,0,0,0,.5.17,2.35,2.35,0,0,0,.69.1,2.27,2.27,0,0,0,.61-.07.94.94,0,0,0,.45-.24.6.6,0,0,0,.19-.46c0-.34-.27-.57-.81-.7l-.92-.24-.67-.19a4.61,4.61,0,0,1-.52-.23,1.09,1.09,0,0,1-.4-.31,1.25,1.25,0,0,1-.23-.41,1.72,1.72,0,0,1-.09-.58,1.4,1.4,0,0,1,.64-1.24,3.08,3.08,0,0,1,1.7-.43,4.42,4.42,0,0,1,1.92.44.5.5,0,0,1,.32.47.44.44,0,0,1-.13.32.39.39,0,0,1-.31.13.5.5,0,0,1-.23-.05l-.13,0-.17-.06-.19-.06-.23-.07-.23,0-.27,0h-.27a1.75,1.75,0,0,0-.76.15.52.52,0,0,0-.15.86,2,2,0,0,0,.66.25l.91.22a3.18,3.18,0,0,1,1.37.64,1.43,1.43,0,0,1,.44,1.12,1.57,1.57,0,0,1-.66,1.37,2.84,2.84,0,0,1-1.71.48,3.82,3.82,0,0,1-2.3-.68A.46.46,0,0,1,295.89,263.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,264.06a2,2,0,0,1-.44-1.39v-3h-.57a.48.48,0,0,1-.53-.5.46.46,0,0,1,.13-.35.5.5,0,0,1,.38-.13h.62l.17-1.45a.86.86,0,0,1,.22-.52.64.64,0,0,1,.51-.21.51.51,0,0,1,.4.17.84.84,0,0,1,.14.51v1.5h.95a.45.45,0,0,1,.37.14.48.48,0,0,1,.13.36.45.45,0,0,1-.13.35.49.49,0,0,1-.38.13h-.94v2.67a2,2,0,0,0,.14.84.52.52,0,0,0,.5.27h.07l.41,0h0a.46.46,0,0,1,.38.16.55.55,0,0,1,.14.39.66.66,0,0,1,0,.25.4.4,0,0,1-.15.17l-.21.1a.9.9,0,0,1-.28.06l-.31,0h-.47A1.61,1.61,0,0,1,302.85,264.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.77,264.12a1.46,1.46,0,0,1-.57-1.23,2.3,2.3,0,0,1,.07-.62,1.5,1.5,0,0,1,.21-.46,1,1,0,0,1,.37-.33,2.91,2.91,0,0,1,.51-.22,4.12,4.12,0,0,1,.68-.13c.28,0,.55-.05.84-.06l1,0v-.45a.92.92,0,0,0-1-1.06h-.23l-.23,0-.2,0-.22.05-.18.05-.19.06-.16.06-.16.06-.13.05a.35.35,0,0,1-.16,0,.44.44,0,0,1-.35-.18.6.6,0,0,1-.14-.39.42.42,0,0,1,.26-.41,5,5,0,0,1,2.16-.45,3.5,3.5,0,0,1,1,.12,2.17,2.17,0,0,1,.76.38,1.68,1.68,0,0,1,.51.7,2.73,2.73,0,0,1,.18,1v3a.71.71,0,0,1-.21.55.69.69,0,0,1-.49.19.71.71,0,0,1-.5-.19.7.7,0,0,1-.2-.55v-.19a1.58,1.58,0,0,1-.61.72,1.93,1.93,0,0,1-1.1.28A2.29,2.29,0,0,1,306.77,264.12Zm2.67-.94a1.61,1.61,0,0,0,.45-1.17v-.17l-.93,0a6.26,6.26,0,0,0-.65.06,1.09,1.09,0,0,0-.45.16.77.77,0,0,0-.23.28,1,1,0,0,0-.09.45.78.78,0,0,0,.24.62.92.92,0,0,0,.63.21A1.4,1.4,0,0,0,309.44,263.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.11,264.29a.9.9,0,0,1-.2-.61v-6.8a.85.85,0,0,1,.21-.61.69.69,0,0,1,.52-.21.73.73,0,0,1,.54.21.85.85,0,0,1,.21.61v6.8a.78.78,0,0,1-.22.6.76.76,0,0,1-1.06,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.18,264.29a.9.9,0,0,1-.2-.61v-6.8a.85.85,0,0,1,.21-.61.69.69,0,0,1,.52-.21.73.73,0,0,1,.54.21.85.85,0,0,1,.21.61v6.8a.81.81,0,0,1-.21.6.74.74,0,0,1-.55.22A.7.7,0,0,1,316.18,264.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.17,257.23a.78.78,0,0,1-.24-.59.76.76,0,0,1,.24-.59.86.86,0,0,1,.62-.22.87.87,0,0,1,.62.22.79.79,0,0,1,.23.59.78.78,0,0,1-.24.59.83.83,0,0,1-.61.22A.86.86,0,0,1,319.17,257.23Zm.09,7.06a.85.85,0,0,1-.21-.61v-4.23a.84.84,0,0,1,.21-.61.7.7,0,0,1,.53-.22.73.73,0,0,1,.53.22.88.88,0,0,1,.2.61v4.23a.85.85,0,0,1-.2.6.76.76,0,0,1-1.06,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,264.29a.83.83,0,0,1-.21-.6v-4.33a.7.7,0,0,1,.21-.54.82.82,0,0,1,1.06,0,.73.73,0,0,1,.2.54v.2a1.72,1.72,0,0,1,.76-.75,2.54,2.54,0,0,1,1.18-.26,2.3,2.3,0,0,1,.79.14,2.17,2.17,0,0,1,.67.4,2,2,0,0,1,.46.71,2.83,2.83,0,0,1,.17,1v2.9a.83.83,0,0,1-.21.6.73.73,0,0,1-.54.21.7.7,0,0,1-.52-.21.87.87,0,0,1-.2-.6v-2.9a1.28,1.28,0,0,0-.32-.93,1.08,1.08,0,0,0-.8-.32,1.34,1.34,0,0,0-1,.47,1.71,1.71,0,0,0-.43,1.2v2.48a.83.83,0,0,1-.21.6.69.69,0,0,1-.53.21A.69.69,0,0,1,322.22,264.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.23,263.56a1.82,1.82,0,0,1-1.75.95,2.69,2.69,0,0,1-2-.79,2.94,2.94,0,0,1-.76-2.12,3.23,3.23,0,0,1,.74-2.2,2.54,2.54,0,0,1,2-.85,2.07,2.07,0,0,1,1.11.25,2.16,2.16,0,0,1,.7.71v-.27a.65.65,0,0,1,.22-.46.71.71,0,0,1,.46-.16.67.67,0,0,1,.5.22.86.86,0,0,1,.19.6v4.81a2.71,2.71,0,0,1-.8,2.11,3.13,3.13,0,0,1-2.19.73,5.19,5.19,0,0,1-1.2-.13,3.09,3.09,0,0,1-.89-.33.49.49,0,0,1-.27-.44.5.5,0,0,1,.14-.35.41.41,0,0,1,.34-.16.72.72,0,0,1,.19,0l.31.11.39.12a2.55,2.55,0,0,0,.36.08,2.74,2.74,0,0,0,.48,0,1.87,1.87,0,0,0,1.28-.41,1.58,1.58,0,0,0,.46-1.24Zm-.41-.52a2.21,2.21,0,0,0,.41-1.47c0-1.36-.5-2-1.49-2a1.38,1.38,0,0,0-.59.11,1.17,1.17,0,0,0-.44.29,1.55,1.55,0,0,0-.3.44,3.5,3.5,0,0,0-.17.55,4.23,4.23,0,0,0-.05.63,2.16,2.16,0,0,0,.44,1.46,1.49,1.49,0,0,0,1.11.51A1.38,1.38,0,0,0,332.82,263Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.59,264.28a.82.82,0,0,1,0-1.16.81.81,0,0,1,.6-.24.85.85,0,0,1,.6.23.76.76,0,0,1,.25.59.8.8,0,0,1-.24.58.88.88,0,0,1-1.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.24,264.28a.82.82,0,0,1,0-1.16.81.81,0,0,1,.6-.24.85.85,0,0,1,.6.23.76.76,0,0,1,.25.59.8.8,0,0,1-.24.58.88.88,0,0,1-1.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,264.28a.82.82,0,0,1,0-1.16.81.81,0,0,1,.6-.24.85.85,0,0,1,.6.23.76.76,0,0,1,.25.59.8.8,0,0,1-.24.58.88.88,0,0,1-1.21,0Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosInstall);
export default __webpack_public_path__ + "static/media/ios-install.c25248d88afddf3de24d1de141275423.svg";
export { ForwardRef as ReactComponent };